<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M4 4v4.308h4.308" stroke="#B503D0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.537 8.308A7 7 0 0118 11a7 7 0 01-13.462 2.692" stroke="#B503D0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>

<script>
  export default {
    name: 'RedoIcon'
  }
</script>
